import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import {
  Form,
  Input,
  Button,
  Space,
  Table,
  Image,
  Modal,
  Select,
  Radio,
  DatePicker,
  Spin,
  message,
  Badge,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import baseRequest from "../../../../utils/baseRequest";
import zh from "antd/es/date-picker/locale/zh_CN";
import ImageUploader from "../../../../components/ImageUploader";
import debounce from "lodash/debounce";
import { DeleteFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
const HotList = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const { confirm } = Modal;
  const [form] = Form.useForm();
  //表头
  const columns = [
    {
      title: "主图",
      dataIndex: "image",
      key: "image",
      width: 120,
      fixed: "left",
      render: (data) => (
        <div className="flex flex-col">
          <div className="flex flex-wrap gap-1">
            {<Image src={data.images[0].urls[0]} width={100} />}
          </div>
        </div>
      ),
    },
    {
      title: "标题",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "文字内容",
      dataIndex: "text",
      key: "text",
    },
    {
      with: 120,
      title: "跳转链接",
      dataIndex: "hyperlinks",
      key: "hyperlinks",
      render: (data) => (
        <div className="flex flex-col flex-wrap gap-1">
          {data.map((hyperlink, index) => (
            <div key={index}>
              <p className="text-[#00000080]">
                {hyperlink.action === "outward"
                  ? "打开新的浏览器页面:"
                  : hyperlink.action === "webViewHeaderInward"
                  ? "应用内打开内链（带头）:"
                  : hyperlink.action === "webViewHeaderOutward"
                  ? "应用内打开外链（带头）:"
                  : hyperlink.action === "webViewWithOutHeaderInward"
                  ? "应用内打开内链（不带头）:"
                  : hyperlink.action === "webViewWithOutHeaderOutward"
                  ? "应用内打开外链（不带头）:"
                  : index
                  ? "H5:"
                  : "App:"}
              </p>
              {hyperlink.action === "outward" ? (
                <a
                  href={hyperlink.url}
                  target="_blank"
                  className="block"
                  style={{ maxWidth: "120px", wordWrap: "break-word" }}
                >
                  {hyperlink.url}
                </a>
              ) : (
                <p style={{ maxWidth: "120px", wordWrap: "break-word" }}>
                  {hyperlink.url}
                </p>
              )}
            </div>
          ))}
        </div>
      ),
    },
    {
      title: "优先级",
      dataIndex: "priority",
      key: "priority",
      width: 90,
      sorter: (a, b) => a.priority - b.priority,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "开始时间",
      dataIndex: "st",
      key: "st",
      width: 120,
      render: (item) => {
        return (
          <span>
            {item ? dayjs(item * 1000).format("YYYY-MM-DD HH:mm:ss") : "-"}
          </span>
        );
      },
    },
    {
      title: "结束时间",
      dataIndex: "et",
      key: "et",
      width: 120,
      render: (item) => {
        return (
          <span>
            {item ? dayjs(item * 1000).format("YYYY-MM-DD HH:mm:ss") : "-"}
          </span>
        );
      },
    },
    {
      title: "状态",
      dataIndex: "status",
      key: "status",
      width: 120,
      fixed: "right",
      filters: [
        {
          text: "推送中",
          value: 0,
        },
        {
          text: "已暂停",
          value: 1,
        },
        {
          text: "已失效",
          value: 2,
        },
        {
          text: "未开始",
          value: 3,
        },
      ],
      filterMode: "tree",
      onFilter: (value, record) => record.status == value,
      sorter: (a, b) => a.status - b.status,
      defaultSortOrder: "ascend",
      sortDirections: ["ascend", "descend"],
      render: (item) => {
        return (
          <span>
            {!item ? (
              <Badge status="processing" text="推送中" />
            ) : item === 1 ? (
              <Badge status="error" text="已暂停" />
            ) : item === 2 ? (
              <Badge status="default" text="已失效" />
            ) : (
              <Badge status="success" text="未开始" />
            )}
          </span>
        );
      },
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      width: 120,
      fixed: "right",
      render: (_, record) => {
        return (
          <div>
            {record.status !== 2 ? (
              <Space size="small" direction="vertical">
                <Space.Compact>
                  <Button type="dashed" onClick={() => handleEditHot(record)}>
                    重新编辑
                  </Button>
                </Space.Compact>
                <Space.Compact direction="vertical">
                  <Button
                    style={{
                      background: record.status === 1 ? "#ffe747" : "#17d983",
                      color: record.status === 1 ? "#333" : "#fff",
                    }}
                    onClick={() =>
                      handlePauseOrStopAndStart(
                        record,
                        record.status === 1 ? 0 : 1
                      )
                    }
                  >
                    {record.status === 1 ? "继续推送" : "暂停推送"}
                  </Button>
                </Space.Compact>
                <Space.Compact direction="vertical">
                  <Button
                    style={{ background: "#ff4d4f", color: "#fff" }}
                    onClick={() => {
                      confirm({
                        icon: <ExclamationCircleOutlined />,
                        content: "确定要结束该推送吗？",
                        okText: "确定",
                        cancelText: "取消",
                        onOk() {
                          handlePauseOrStopAndStart(record, 2);
                        },
                        onCancel() {
                          // console.log('Cancel');
                        },
                      });
                    }}
                  >
                    结束推送
                  </Button>
                </Space.Compact>
              </Space>
            ) : (
              <Button disabled>已失效</Button>
            )}
          </div>
        );
      },
    },
  ];
  //给表单绑定ref
  const formRef = useRef(null);
  //提交表单
  const handleSubmit = async (value, type) => {
    const {
      action,
      status,
      image,
      pageName,
      hyperlinks,
      st,
      et,
      link,
      ueser_id,
      id,
      mid,
      innerMid,
    } = value;

    let newHyperlinks = [];
    if (hyperlinks) {
      newHyperlinks = hyperlinks;
    } else {
      const paramsObj = pageName ? JSON.parse(pageName) : null;
      newHyperlinks = paramsObj
        ? [
            {
              url: paramsObj.app_route_path.replace(
                "MID",
                selectedStreamer.mid
              ),
              action,
              frontend_route_id: paramsObj.id,
              inward_action_type: "app",
            },
            {
              url: paramsObj.h5_route_path.replace(
                "[mid]",
                selectedStreamer.mid
              ),
              action,
              inward_action_type: "h5",
              frontend_route_id: paramsObj.id,
            },
          ]
        : [
            {
              url: link,
              action,
              inward_action_type: "outward",
            },
          ];
    }
    if (typeof id !== "number") {
      if (!status && new Date(st).getTime() < new Date().getTime()) {
        messageApi.open({
          type: "warning",
          content: "推送时间不能早于当前时间",
        });
        return;
      } else if (!status && new Date(st).getTime() > new Date(et).getTime()) {
        messageApi.open({
          type: "warning",
          content: "结束时间不能早于开始时间",
        });
        return;
      } else if (
        new Date(et).getTime() - new Date(st).getTime() <
        10 * 60 * 1000
      ) {
        messageApi.open({
          type: "warning",
          content: "两个时间间隔最短不小于10分钟",
        });
        return;
      }
    }

    try {
      //通过图片审核，如果是视频直接跳过
      const dataObj = {
        ...value,
        st: Math.floor(new Date(st).getTime() / (60 * 1000)) * 60,
        et: Math.floor(new Date(et).getTime() / (60 * 1000)) * 60,
        hyperlinks: newHyperlinks,
        image: image?.images ? image : { image_ids: displayImageId },
        user_id: "",
        mid:
          selectedStreamer?.inputType === "outter"
            ? mid
            : innerMid
            ? null
            : mid,
      };

      if (typeof id === "number") {
        delete dataObj.st;
        delete dataObj.et;
      }
      if (
        type === "stopStart" ||
        dataObj.priority === selectedStreamer?.priority
      ) {
        delete dataObj.priority;
      }

      const base = baseRequest();
      const body = JSON.stringify({
        ...dataObj,
        ...base,
      });
      const response = await fetch(
        `/op/activity_hot/${id !== null ? "update" : "create"}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body,
        }
      );
      const _data = await response.json();
      if (_data.ret === -1) {
        alert(_data.msg);
        return;
      }
      message.success(id ? "更新成功" : "创建成功");
      handleCancelModal();
      getData(hotStatus, true, 0);
    } catch (error) {
      message.error("服务器错误");
    }
  };
  //获取数据
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [more, setMore] = useState(1);
  const [displayImageId, setDisplayImageId] = useState([]);
  const [pagesOptions, setPagesOptions] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [currentPageName, setCurrentPageName] = useState("");
  const [buttonAble, setButtonAble] = useState(false);
  const [formData, setFormData] = useState({
    mid: null,
    title: "",
    image: "",
    text: "",
    hyperlinks: "",
    priority: null,
    st: "",
    et: "",
    status: 0,
    action: null,
    pageName: null,
    params: "",
    link: "",
    ueser_id: null,
    id: null,
  });
  const [miniDate, setMiniDate] = useState(null);
  const [pathMethod, setPathMethod] = useState("");
  const [zones, setZones] = useState(null);
  const [selectedStreamer, setSelectedStreamer] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const buddhistLocale = {
    ...zh,
    lang: {
      ...zh.lang,
      fieldDateFormat: "YYYY-MM-DD",
      fieldDateTimeFormat: "YYYY-MM-DD HH:mm",
      yearFormat: "YYYY",
      cellYearFormat: "YYYY",
    },
  };
  const currentPagesOptions = useMemo(() => {
    if (!pagesOptions.length) return [];
    const pages = pagesOptions
      .filter((it) => it.desc === "达人空间")
      .map((it) => {
        return {
          label: it.desc,
          value: JSON.stringify(it),
        };
      });
    return pages;
  }, [pagesOptions, formData.action]);
  const onTimeOk = (value) => {
    console.log("onOk: ", value);
  };
  const [hotStatus, setHotStatus] = useState(undefined);
  //表头可见性表单的checkbox选项
  const showColumnsOptions = [
    {
      label: "全部",
      value: undefined,
    },
    {
      label: "未开始推送",
      value: 3,
    },
    {
      label: "推送中",
      value: 0,
    },
    {
      label: "暂停推送",
      value: 1,
    },
    {
      label: "已失效",
      value: 2,
    },
  ];
  const getPages = async () => {
    try {
      const base = baseRequest();
      const response = await fetch("/op/frontend_route/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          offset: 0,
          limit: 10,
          ...base,
        }),
      });
      const _data = await response.json();
      if (_data.ret === -1) {
        alert(_data.msg);
        return;
      }
      setPagesOptions(_data.data.list);
    } catch (error) {
      console.error(error);
    }
  };
  const getData = async (status, isFirst, offset) => {
    // if (!more) return;
    setIsLoading(true);
    try {
      const base = baseRequest();
      const response = await fetch("/op/activity_hot/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          offset,
          limit: 100,
          status,
          ...base,
        }),
      });
      const temData = await response.json();
      if (temData.ret === -1) {
        alert(temData.msg);
        return;
      }

      setData((old) =>
        isFirst ? temData.data.list : [...old, ...temData.data.list]
      );

      setOffset(temData.data.offset);
      setMore(temData.data.more);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleEditHot = async (data) => {
    setIsModalOpen(true);
    const { hyperlinks, st, et, mid, status, user_id, id, innerMid } = data;
    const newSt = dayjs(st * 1000);
    const newEt = dayjs(et * 1000);
    const currentPageId = hyperlinks?.[0].frontend_route_id;
    const params = hyperlinks[0]?.url?.split("?")[1];
    const action = hyperlinks[0].action;
    const link = action === "inward" ? "" : hyperlinks[0].url;

    const isCurrentPagePath = pagesOptions.filter(
      (it) => it.id === currentPageId
    );
    const pageName =
      action === "inward" ? JSON.stringify(isCurrentPagePath[0]) : "";
    setCurrentPageName(pageName);
    setPathMethod(action);
    setCurrentStatus(
      !status
        ? "推送中"
        : status === 1
        ? "已暂停"
        : status === 2
        ? "已失效"
        : "未开始"
    );
    setSelectedStreamer(data);
    setDisplayImageId(data?.image?.image_ids);
    await handleSearchMid(user_id);

    form.setFieldsValue({
      ...data,
      st: newSt,
      et: newEt,
      pageName,
      action,
      link,
      params,
      hyperlinks: "",
      mid,
      innerMid: mid || parseInt(params?.split("=")[1]),
      user_id,
      id,
    });
  };
  const handlePauseOrStopAndStart = (data, status) => {
    const { st, et, hyperlinks } = data;
    const isCurrentPagePath = pagesOptions.filter(
      (it) =>
        it.h5_route_path.indexOf(currentPageName) !== -1 ||
        it.app_route_path.indexOf(currentPageName) !== -1
    );
    const action = hyperlinks[0].action;
    const pageName =
      action === "inward"
        ? JSON.stringify(isCurrentPagePath[0])
        : hyperlinks[0].url;
    handleSubmit(
      {
        ...data,
        pageName,
        st: st * 1000,
        et: et * 1000,
        status,
      },
      "stopStart"
    );
  };
  //搜索空间
  const handleSearchMid = async (mid) => {
    // const mid = form.getFieldValue("mid");
    if (!mid) return;
    setIsLoading(true);
    try {
      const base = baseRequest();
      const detailResponse = await fetch(`/op/zone/list_by_user_id`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: parseInt(mid, 10),
          ...base,
        }),
      });
      const detailData = await detailResponse.json();
      if (detailData.ret === -1) {
        alert(detailData.msg);
        return;
      }
      console.log(
        "temData.data.list 621957",
        detailData.data.list[0].streamer_ext.avatar.image_ids
      );
      // setDisplayImageId(detailData.data.list[0].streamer_ext.avatar.image_ids);
      const zonesArr = detailData.data.list;
      setZones(zonesArr);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData(hotStatus, true, 0);
  }, [hotStatus]);
  useEffect(() => {
    getPages();
  }, []);

  //展示的数据
  const [showData, setShowData] = useState([]);
  useEffect(() => {
    setShowData(data);
  }, [data]);
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  //关闭弹窗
  const handleCancelModal = () => {
    form.setFieldsValue(formData);
    setPathMethod("");
    setSelectedStreamer(null);
    setIsModalOpen(false);
    setZones(null);
    setDisplayImageId([]);
    setCurrentStatus(null);
    form.setFieldValue("mid", null);
  };

  const currentStreamerImage = useMemo(() => {
    console.log("form.validateFields", selectedStreamer);
    if (selectedStreamer && zones) {
      if (
        zones[0].streamer_ext.avatar.image_ids[0] === displayImageId[0]
        // && !displayImageId.length
      ) {
        setDisplayImageId(zones[0].streamer_ext.avatar.image_ids);
        form.setFieldValue("image", zones[0].streamer_ext.avatar);
        return zones[0]?.streamer_ext.avatar.images[0].urls[0];
      } else if (
        selectedStreamer?.image &&
        selectedStreamer?.image?.image_ids[0] === displayImageId[0]
      ) {
        setDisplayImageId(selectedStreamer.image.image_ids);
        return selectedStreamer.image.images[0].urls[0];
      } else {
        return null;
      }
    } else if (
      selectedStreamer &&
      selectedStreamer?.image?.image_ids[0] === displayImageId[0]
    ) {
      setDisplayImageId(selectedStreamer.image.image_ids);
      return selectedStreamer.image.images[0].urls[0];
    } else {
      return null;
    }
  }, [zones, selectedStreamer, displayImageId]);
  const findBracketedFields = (text) => {
    const regex = /\[(.*?)\]/g;
    const matches = [];
    let match;

    while ((match = regex.exec(text)) !== null) {
      matches.push(match[1]);
    }

    return matches;
  };
  const getSplitParams = useCallback((currentPageName) => {
    const newCurrentPageName =
      form.getFieldValue("pageName") || currentPageName;
    if (!newCurrentPageName) return [];
    const CurrentPageNameObj = JSON.parse(newCurrentPageName);
    const { app_route_path, h5_route_path } = CurrentPageNameObj;
    const newCurrentPageNameStr = app_route_path || h5_route_path;
    if (
      newCurrentPageNameStr.indexOf("?") !== -1 ||
      newCurrentPageNameStr.indexOf("[") !== -1
    ) {
      if (newCurrentPageNameStr.indexOf("?") !== -1) {
        const splitParamsStr = newCurrentPageNameStr.split("?")[1];
        return splitParamsStr.split("&").map((item) => item.split("=")[0]);
      }
      // const regex = /\[.*?\]/g;
      if (newCurrentPageNameStr) {
        // const matches = [];
        // let match;
        // while ((match = regex.exec(newCurrentPageNameStr)) !== null) {
        //   matches.push(match[1]);
        //   console.log("Regex: ", match[1]);
        // }
        const matches = findBracketedFields(newCurrentPageNameStr);
        console.log("Regex: ", matches);
        return matches;
      } else {
        return [];
      }
    } else {
      return [];
    }
  });
  const splitParams = useMemo(() => {
    const list = getSplitParams(currentPageName);
    if (selectedStreamer) {
      list.forEach((it) => {
        form.setFieldValue(it, selectedStreamer[it]);
      });
    }

    return list;
  }, [currentPageName, pathMethod, selectedStreamer]);
  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <div className="flex justify-between items-center">
        <div style={{ marginTop: 20, marginBottom: 10 }}>
          <p style={{ display: "inline" }}>热榜状态：</p>
          <Radio.Group
            options={showColumnsOptions}
            defaultValue={hotStatus}
            onChange={(e) => setHotStatus(e.target.value)}
          />
        </div>
        <Button
          type="primary"
          className="mt-4 mb-4 float-right"
          onClick={() => setIsModalOpen(true)}
        >
          新建热榜+
        </Button>
      </div>
      {contextHolder}
      <ConfigProvider locale={zhCN}>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={showData}
          pagination={{ pageSize: 20, showSizeChanger: false }}
          scroll={{ y: window.innerHeight - 300 }}
          footer={() => (
            <div className="text-gray-400">获得总数：{showData.length}</div>
          )}
          onScroll={(e) => {
            const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;
            if (scrollTop + clientHeight + 5 >= scrollHeight && more) {
              getData(hotStatus, false, offset);
            }
          }}
        />
      </ConfigProvider>

      <Modal
        title={!currentStatus ? "新建热榜" : "修改热榜"}
        footer={null}
        open={isModalOpen}
        onCancel={handleCancelModal}
      >
        <p style={{ display: currentStatus ? "block" : "none" }}>
          <span className="text-[#00000080]">推送状态：</span>
          {currentStatus}
        </p>

        <Form
          label="streamer"
          className="mt-4 flex flex-col"
          form={form}
          onFinish={handleSubmit}
          onFinishFailed={(error) => console.log(error)}
          layout="vertical"
          initialValues={formData}
        >
          {!currentStatus && (
            <div style={{ marginBottom: 20 }} className="flex-1">
              <Form.Item
                label="ID"
                name="mid"
                layout="horizontal"
                style={{
                  margin: 0,
                  display:
                    selectedStreamer?.inputType === "inner" ? "none" : "block",
                }}
              >
                <Select
                  // style={{
                  //   width: 240,
                  // }}
                  disabled={selectedStreamer?.inputType === "inner"}
                  className="w-full"
                  showSearch
                  allowClear
                  placeholder="通过ID搜索达人"
                  // optionFilterProp="label"
                  onChange={(v) => {
                    if (selectedStreamer?.inputType === "inner") return;
                    const currentIt = zones?.filter((it) => it.mid == v)[0];
                    if (currentIt) {
                      setSelectedStreamer({
                        ...currentIt,
                        inputType: "outter",
                      });
                      setDisplayImageId(
                        currentIt.streamer_ext.avatar.image_ids
                      );
                      form.setFieldsValue({
                        mid: v,
                        title:
                          // form.getFieldValue("title") ||
                          currentIt.streamer_ext.name,
                        // image: displayImageId[0] || currentIt.streamer_ext.avatar,
                        text:
                          // form.getFieldValue("text") ||
                          currentIt.profile,
                      });
                    } else {
                      setSelectedStreamer(null);
                      form.setFieldsValue({
                        mid: null,
                      });
                    }
                  }}
                  filterOption={false}
                  onSearch={debounce(handleSearchMid, 1000)}
                  notFoundContent={isLoading ? <Spin size="small" /> : null}
                  options={zones?.map((it) => ({
                    value: it.mid,
                    label: (
                      <div className="flex">
                        <p className="font-bold w-1/4 min-w-[150px]">
                          ID：{it?.streamer_ext?.user_id}
                        </p>
                        <p className="font-bold w-3/4">
                          昵称：{it?.streamer_ext.name}
                        </p>
                      </div>
                    ),
                  }))}
                  labelRender={({ value }) => {
                    const currentIt = zones?.filter((it) => it.mid == value)[0];
                    if (currentIt) {
                      return currentIt.streamer_ext.name;
                    }
                    return <span>No option match</span>;
                  }}
                />
              </Form.Item>
            </div>
          )}
          <Form.Item
            label="主图"
            name="image"
            rules={[
              {
                required: true,
                message: "请上传主图",
              },
            ]}
            className="mb-6"
          >
            <div className="relative inline-block group">
              {currentStreamerImage && displayImageId.length > 0 ? (
                <Image
                  src={currentStreamerImage}
                  width={100}
                  className="m-[5px] rounded-[8px]"
                />
              ) : (
                <ImageUploader
                  setIds={setDisplayImageId}
                  ids={displayImageId}
                  uploadOne={true}
                  preventEvent={setButtonAble}
                />
              )}
              <div
                style={{
                  visibility:
                    currentStreamerImage || displayImageId.length
                      ? "visible"
                      : "hidden",
                }}
                className="absolute top-4 -right-3 -mt-4 px-1 hidden rounded-full cursor-pointer bg-[#ffeceb] text-[#ff7875] group-hover:block hover:scale-125"
                onClick={() => setDisplayImageId([])}
              >
                <DeleteFilled />
              </div>
            </div>
          </Form.Item>
          <Form.Item
            label="标题"
            name="title"
            rules={[
              {
                required: true,
                message: "请填写通知标题",
              },
            ]}
            className="mb-6"
          >
            <Input maxLength={20} placeholder="字数上限为20" />
          </Form.Item>
          <Form.Item
            label="文字内容"
            name="text"
            rules={[
              {
                required: true,
                message: "请填写通知标题",
              },
            ]}
            className="mb-6"
          >
            <Input maxLength={200} placeholder="字数上限为200" />
          </Form.Item>
          <Space
            direction="vertical"
            className="bg-[#00000011] rounded-md p-4 mb-4"
          >
            <Form.Item
              label="跳转形式"
              name="action"
              className="mb-2"
              rules={[
                {
                  required: true,
                  message: `请选择跳转形式`,
                },
              ]}
            >
              <Select
                placeholder="选择跳转形式"
                style={{
                  width: 240,
                }}
                value={formData.action}
                onChange={(e) => {
                  form.setFieldsValue({
                    pageName: "",
                    link: "",
                    params: "",
                    hyperlinks: "",
                    mid: null,
                    innerMid: null,
                  });
                  setPathMethod(e);
                }}
                options={[
                  {
                    value: "inward",
                    label: "达人空间跳转",
                  },
                  {
                    value: "outward",
                    label: "打开新的浏览器页面",
                  },
                  {
                    value: "webViewHeaderOutward",
                    label: "应用内打开外链（带头）",
                  },
                  {
                    value: "webViewHeaderInward",
                    label: "应用内打开内链（带头）",
                  },
                  {
                    value: "webViewWithOutHeaderOutward",
                    label: "应用内打开外链（不带头）",
                  },
                  {
                    value: "webViewWithOutHeaderInward",
                    label: "应用内打开内链（不带头）",
                  },
                ]}
              />
            </Form.Item>

            <div>
              <div>
                <div
                  style={{
                    display:
                      pathMethod !== "inward" && pathMethod ? "block" : "none",
                  }}
                >
                  <Form.Item
                    rules={[
                      {
                        required: pathMethod !== "inward" && pathMethod,
                        message: "请填写具体链接地址",
                        pattern: /^(https?:\/\/).*$/,
                      },
                    ]}
                    label="跳转位置"
                    name="link"
                    className="mb-2"
                  >
                    <Input placeholder="填写外部跳转链接，如：https://..." />
                  </Form.Item>
                </div>
                <Space
                  direction="vertical"
                  className="w-full"
                  style={{
                    display: pathMethod == "inward" ? "block" : "none",
                  }}
                >
                  <label>
                    <span className="text-[red] mr-1 ">*</span>跳转位置
                  </label>
                  <div className="grid grid-cols-2 items-start mt-2">
                    <Space align="center">
                      <Form.Item
                        name="pageName"
                        className="mb-2"
                        rules={[
                          {
                            required: pathMethod == "inward",
                            message: `请选择页面`,
                          },
                        ]}
                      >
                        <Select
                          placeholder="选择页面"
                          style={{
                            width: 160,
                          }}
                          onChange={setCurrentPageName}
                        >
                          {currentPagesOptions.length > 0 &&
                            currentPagesOptions.map((it) => {
                              return (
                                <Select.Option key={it.id} value={it.value}>
                                  {it.label}
                                </Select.Option>
                              );
                            })}
                          {/* <Select.Option value={1}>x1</Select.Option>
                            <Select.Option value={2}>x2</Select.Option>
                            <Select.Option value={3}>x3</Select.Option>
                            <Select.Option value={5}>x5</Select.Option> */}
                        </Select>
                      </Form.Item>
                      {splitParams.length > 0 && (
                        <div className="-mt-2 mx-2">?</div>
                      )}
                    </Space>
                    <Space
                      direction="vertical"
                      className="bg-white rounded-xl p-4"
                    >
                      <Form.Item name="innerMid" className="mb-0">
                        <Select
                          // style={{
                          //   width: 240,
                          // }}
                          className="w-full"
                          style={{
                            display:
                              selectedStreamer?.inputType === "outter"
                                ? "none"
                                : "block",
                          }}
                          // value={selectedStreamer?.mid}
                          showSearch
                          allowClear
                          placeholder="通过ID搜索达人"
                          // optionFilterProp="label"
                          onChange={(v) => {
                            if (selectedStreamer?.inputType === "outter")
                              return;
                            const currentIt = zones?.filter(
                              (it) => it.mid == v
                            )[0];
                            // if (currentIt) {
                            //   setSelectedStreamer(currentIt);
                            // } else {
                            //   setSelectedStreamer(null);
                            // }
                            if (currentIt) {
                              form.setFieldValue("innerMid", currentIt.mid);
                              setSelectedStreamer({
                                ...currentIt,
                                inputType: "inner",
                                mid: currentIt.mid,
                              });
                            }
                          }}
                          onClear={() => {
                            form.setFieldValue("innerMid", null);
                            setSelectedStreamer(null);
                            setZones(null);
                          }}
                          filterOption={false}
                          onSearch={debounce(handleSearchMid, 1000)}
                          notFoundContent={
                            isLoading ? <Spin size="small" /> : null
                          }
                          options={zones?.map((it) => ({
                            value: it.mid,
                            label: (
                              <div>
                                <p className="font-bold w-1/4">ID：{it?.mid}</p>
                                <p className="font-bold w-3/4">
                                  昵称：{it?.streamer_ext.name}
                                </p>
                              </div>
                            ),
                          }))}
                          labelRender={({ value }) => {
                            const currentIt = zones?.filter(
                              (it) => it.mid == value
                            )[0];
                            if (currentIt) {
                              return currentIt.streamer_ext.name;
                            }
                            return <span>No option match</span>;
                          }}
                        />
                      </Form.Item>
                      {splitParams.map((it) => (
                        <Form.Item
                          name={it}
                          className="mb-2"
                          rules={[
                            {
                              required: pathMethod == "inward",
                              message: `请填写${it}的值`,
                            },
                          ]}
                        >
                          <div className="px-2 py-1 rounded bg-[#93939340]">
                            {it}：{selectedStreamer?.mid}
                          </div>
                          {/* {selectedStreamer?.mid} */}
                          <Input
                            disabled
                            className="bg-gray-200 hidden"
                            placeholder="参数值"
                            prefix={<span>{it}：</span>}
                            value={selectedStreamer?.mid}
                          />
                        </Form.Item>
                      ))}
                    </Space>
                  </div>
                </Space>
              </div>
            </div>
          </Space>
          <Form.Item
            label="优先级"
            name="priority"
            rules={[
              {
                required: true,
                message: "请填写通知标题",
              },
            ]}
            className="mb-6"
          >
            <Select
              placeholder="选择优先级"
              style={{
                width: 140,
              }}
              // value={formData.action}
              options={Array.from(Array(20)).map((_, index) => ({
                value: index + 1,
                label: index + 1,
              }))}
            />
          </Form.Item>
          <Form.Item
            label="开始时间"
            name="st"
            format="YYYY-MM-DD HH:mm"
            rules={[
              {
                required: true,
                message: "请选择时间",
              },
            ]}
            className="mb-6"
          >
            <DatePicker
              showTime
              disabled={currentStatus}
              // disabled={true} // locale={{
              //   lang: { locale: "zh_CN", placeholder: "选择日期时间" },
              // }}
              minDate={dayjs(new Date())}
              locale={buddhistLocale}
              onChange={(value, dateString) => {
                // console.log("Time: ", new Date());
                setMiniDate(value ? value : dayjs(new Date()));
                console.log("Selected Time: ", value);
                console.log("Formatted Selected Time: ", dateString);
              }}
              onOk={onTimeOk}
            />
          </Form.Item>
          <Form.Item
            label="结束时间"
            name="et"
            format="YYYY-MM-DD HH:mm"
            rules={[
              {
                required: true,
                message: "请选择时间",
              },
            ]}
            className="mb-6"
          >
            <DatePicker
              minDate={miniDate || formData.st}
              disabled={currentStatus}
              showTime
              // locale={{
              //   lang: { locale: "zh_CN", placeholder: "选择日期时间" },
              // }}
              locale={buddhistLocale}
              onChange={(value, dateString) => {
                // console.log("Time: ", new Date());
                console.log("Selected Time: ", value);
                console.log("Formatted Selected Time: ", dateString);
              }}
              onOk={onTimeOk}
            />
          </Form.Item>
          <Form.Item layout="horizontal" name="id" className="hidden">
            <Input />
          </Form.Item>
          <Form.Item label={null}>
            <Button type="primary" htmlType="submit" disabled={buttonAble}>
              确认
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default HotList;
